import React, { useMemo } from 'react';
import { Link, LinkProps, useLocation } from 'react-router-dom';
import { getHistoryStateforSameParent, getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';

interface OWLinkProps extends LinkProps {
	className?: string;
	preserveBackLinkStates?: boolean;
	sameParent?: boolean;
	backText?: string;
}

const OWLink: React.FC<OWLinkProps> = ({
	className,
	children,
	to,
	preserveBackLinkStates,
	backText,
	sameParent,
	...props
}) => {
	const location = useLocation();

	const url = useMemo(() => {
		if (preserveBackLinkStates) {
			return getLinkWIthBackLinkParams(location, backText || 'Back', to);
		}
		if (sameParent) {
			return getHistoryStateforSameParent(location, to);
		}
		return to;
	}, [backText, location, preserveBackLinkStates, sameParent, to]);
	return (
		<Link to={url} className={className} {...props}>
			{children}
		</Link>
	);
};

export default OWLink;
